import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Card, CardBody, Row, Col, Table, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from "reactstrap"
import { salesDeveloperPrefix } from "configs/routePrefix"
import { toast } from "react-toastify"
import { SuccessOk } from "configs/statusCode"
import { ImagePreview, PreviewContainer } from "components/Common/file-upload/file-upload.styles";
import moment from "moment"
import { useSelector } from "react-redux"
import Pagination from "pages/SalesDeveloper/Deals/Pagination"
import DealService from "services/SalesDeveloper/DealService"

const ViewDealPage = (props) => {
    const dealService = new DealService()
    const [deal, setDeal] = useState(null);
    const [activities, setActivities] = useState([]);
    const [feedback, setFeedback] = useState([]);
    const [dropdownStatus, setDropdownStatus] = useState(false);
    const AuthData = useSelector(state => state.Auth)
    const isExist = (data) => AuthData.permissions[data]
    const id = props.match.params.id
    const toggleStausDropdown = () => setDropdownStatus(prevState => !prevState);
    const [formState, setFormState] = useState({})
    const [status, setStatus] = useState()

    const getDealData = () => {
        dealService.find(id).then(response => {
            if (response && response.status === SuccessOk) {
                setDeal(response.data)
                setFormState({...formState,media: response.data?.reciept, status: response.data?.status})
                setStatus(response.data?.status)
            }
        })
    }

    useEffect(()=>{
        getDealData()
    },[])

    const onChangeActivities = (listData) => {
        setActivities([...listData])
    }
    const onChangeFeedback = (listData) => {
        setFeedback([...listData])
    }
    const custimizeQueries = (query) => {
        const custimizedQuery = []
        for (let key in query) {
            if (query[key] !== "" && key !== "query" && key !== "id" && key !== "date") {
                custimizedQuery.push(`${key} : ${query[key]}`)
            }
        }
        return custimizedQuery
    }



    const changeStateHandler = (status) => {
        dealService.update(id, { status }).then(res => {
            if (res && res.status === SuccessOk) {
                setDeal({ ...deal, status })
                toast.success("Status changed successfully")
                getDealData()
            }
        })
    }
    return (
        <React.Fragment>
            <div className='page-content view-deal-page'>
                <MetaTags>
                    <title>View Deal</title>
                </MetaTags>
                <Container fluid>
                    <Row>
                        <Card>
                            <CardBody>
                                <Row>
                                    <Col md={8}>
                                        <h4>
                                            <button className="p-0 m-0 border-0 bg-light"
                                                onClick={() => {
                                                    props.history.push(`${salesDeveloperPrefix}/deals`)
                                                }}>
                                                <i className="fa fa-arrow-left text-success me-2"></i>
                                            </button>
                                            View Deal
                                           <span className="mx-2">
                                                <Dropdown color="light" isOpen={dropdownStatus} toggle={toggleStausDropdown}>
                                                    <DropdownToggle >
                                                        <Badge
                                                            className="font-size-14 m-0 text-white p-2"
                                                            style={{ background: getBackGround(status) }}
                                                        >
                                                            {status} <i className="fas fa-chevron-down text-white"></i>
                                                        </Badge>
                                                    </DropdownToggle>
                                                    {isExist("manage_deals_status") && <DropdownMenu>
                                                        {status && ["Lost", "Won", "Open", "Closed", "Contacted", "Uncontacted", "Unreachable"].filter(item => item !== status).map((status, index) => {
                                                            return (
                                                                <DropdownItem key={index} onClick={() => changeStateHandler(status)}>{status}</DropdownItem>
                                                            )
                                                        })}
                                                    </DropdownMenu>}
                                                </Dropdown>
                                                {deal?.unit_status && <Badge
                                                    className="font-size-14 m-0 text-white p-2 bg-primary" >
                                                    {deal ?.unit_status}
                                                </Badge>}
                                            </span>
                                        </h4>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Row>

                    <Row className="mx-0">
                        <Col md={6} className="px-2" >
                            <Card className="mt-2 ">
                                <CardBody className="pb-0">
                                    <Row className="mb-4  mx-1">
                                        <Row className="mb-0 px-0">
                                            <p className="fw-bold font-size-16 mb-1">Basic info</p>
                                            <p className="font-size-14 text-muted mb-0">Here all the information related to Deal</p>
                                        </Row>
                                        <hr className="mt-1 mb-2" />
                                        <Row className="mb-0">
                                            <Col md={12} className="mb-2">
                                                <Row className="font-size-14 text-muted mb-0">Name</Row>
                                                <Row className="fw-bold">{deal ?.title}</Row>
                                            </Col>
                                            <Col md={6}>
                                                <Row className="font-size-14 text-muted mb-0">Sales Rep</Row>
                                                <Row className="fw-bold">{deal ?.sales_rep.name}</Row>
                                            </Col>
                                            <Col md={6}>
                                                <Row className="font-size-14 text-muted mb-0">Date of creation</Row>
                                                <Row className="fw-bold">{deal ?.created_at ? moment(deal ?.created_at).format("DD MMMM YYYY hh:mm A") : ""}</Row>
                                            </Col>
                                        </Row>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md={6} className="px-2" >
                            <Card className="mt-2  ">
                                <CardBody className="pb-0">
                                    <Row className="mb-4  mx-1">
                                        <Row className="mb-0 px-0">
                                            <p className="fw-bold font-size-16 mb-1">Lead informations</p>
                                            <p className="font-size-14 text-muted mb-0">All the informations related to the Lead</p>
                                        </Row>
                                        <hr className="mt-1 mb-2" />
                                        <Row className="mb-0">
                                            <Col md={12} className="mb-2">
                                                <Row className="font-size-14 text-muted mb-0">Client</Row>
                                                <Row className="fw-bold">{deal ?.client ?.name}</Row>
                                            </Col>
                                            <Col md={6}>
                                                <Row className="font-size-14 text-muted mb-0">Phone</Row>
                                                <Row className="fw-bold">{deal ?.client ?.phone}</Row>
                                            </Col>
                                            <Col md={6}>
                                                <Row className="font-size-14 text-muted mb-0">Email</Row>
                                                <Row className="fw-bold">{deal ?.client ?.email}</Row>
                                            </Col>
                                        </Row>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    {deal?.unit && <Row className="px-0 mx-2">
                        <Card className="mt-2 px-0  mr-2 ">
                            <CardBody className="pb-0">
                                <Row className="mb-4  mx-1">
                                    <Row className="mb-0 px-0">
                                        <p className="fw-bold font-size-16 mb-1">Deal Unit</p>
                                        <p className="font-size-14 text-muted mb-0">All the informations related to the deal</p>
                                    </Row>
                                    <hr className="mt-1 mb-2" />
                                    <Row>
                                        
                                        <Col md={3} className="my-2 ">
                                            <Row className="font-size-14 text-muted">Unit Code</Row>
                                            <Row className="fw-bold">{deal ?.unit ?.name ?.en}</Row>
                                        </Col>
                                        <Col md={3} className="my-2 ">
                                            <Row className="font-size-14 text-muted">Location</Row>
                                            <Row className="fw-bold">{deal?.unit?.area?.name?.en}</Row>
                                        </Col>
                                        <Col md={3} className="my-2 ">
                                            <Row className="font-size-14 text-muted">Compound Name</Row>
                                            <Row className="fw-bold">{deal ?.unit ?.compound ?.name ?.en}</Row>
                                        </Col>
                                        <Col md={3} className="my-2 ">
                                            <Row className="font-size-14 text-muted">Size</Row>
                                            <Row className="fw-bold">{parseInt(deal ?.unit ?.size)} m</Row>                                        </Col>
                                        <Col md={3} className="my-2 ">
                                            <Row className="font-size-14 text-muted">Price</Row>
                                            <Row className="fw-bold">{toCurrency(deal ?.unit ?.price)}</Row>
                                        </Col>
                                        <Col md={3} className="my-2 ">
                                            <Row className="font-size-14 text-muted">Installments</Row>
                                            <Row className="fw-bold">{deal ?.unit ?.installment ? `Up to ${deal ?.unit ?.installment} years installments` : " Cash only"}</Row>
                                        </Col>
                                        <Col md={3} className="my-2 ">
                                            <Row className="font-size-14 text-muted">Unit Type</Row>
                                            <Row className="fw-bold">{deal ?.unit ?.unit_type ?.name ?.en}</Row>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {deal ?.unit ?.images ?.length > 0 &&
                                            <Row className="my-4">
                                                <Row className="py-2 px-1">
                                                    {deal ?.unit ?.images.map((file, index) => {
                                                        if (file ?.path) {
                                                            return (
                                                                <PreviewContainer key={index}>
                                                                    <ImagePreview
                                                                        src={file.path}
                                                                        alt={`file preview ${index}`}
                                                                    />
                                                                </PreviewContainer>
                                                            )
                                                        }
                                                    })}
                                                </Row>
                                            </Row>}
                                    </Row>
                                </Row>
                            </CardBody>
                        </Card>
                    </Row>}

                    {deal?.resale && <Row className="px-0 mx-2">
                        <Card className="mt-2 px-0  mr-2 ">
                            <CardBody className="pb-0">
                                <Row className="mb-4  mx-1">
                                    <Row className="mb-0 px-0">
                                        <p className="fw-bold font-size-16 mb-1">Deal Unit</p>
                                        <p className="font-size-14 text-muted mb-0">All the informations related to the deal</p>
                                    </Row>
                                    <hr className="mt-1 mb-2" />
                                    <Row>
                                        <Col md={3} className="my-2 ">
                                            <Row className="font-size-14 text-muted">Unit Code</Row>
                                            <Row className="fw-bold">{deal ?.resale ?.name ?.en}</Row>
                                        </Col>
                                        <Col md={3} className="my-2 ">
                                            <Row className="font-size-14 text-muted">Location</Row>
                                            <Row className="fw-bold">{deal?.resale ?.area ?.name}</Row>
                                        </Col>
                                        {!!deal?.compound?.name ?.en && <Col md={3} className="my-2 ">
                                            <Row className="font-size-14 text-muted">Compound Name</Row>
                                            <Row className="fw-bold">{deal ?.compound ?.name ?.en}</Row>
                                        </Col>}
                                        <Col md={3} className="my-2 ">
                                            <Row className="font-size-14 text-muted">Size</Row>
                                            <Row className="fw-bold">{parseInt(deal ?.resale ?.total_built_up_area)} m</Row>                                        </Col>
                                        <Col md={3} className="my-2 ">
                                            <Row className="font-size-14 text-muted">Price</Row>
                                            <Row className="fw-bold">{toCurrency(deal ?.resale ?.payment_plan?.total_price)}</Row>
                                        </Col>
                                        <Col md={3} className="my-2 ">
                                            <Row className="font-size-14 text-muted">Installments</Row>
                                            <Row className="fw-bold">{deal ?.unit ?.installment ? `Up to ${deal ?.unit ?.installment} years installments` : " Cash only"}</Row>
                                        </Col>
                                        <Col md={3} className="my-2 ">
                                            <Row className="font-size-14 text-muted">Unit Type</Row>
                                            <Row className="fw-bold">{deal ?.resale ?.resale_type ?.name ?.en}</Row>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {deal ?.unit ?.images ?.length > 0 &&
                                            <Row className="my-4">
                                                <Row className="py-2 px-1">
                                                    {deal ?.unit ?.images.map((file, index) => {
                                                        if (file ?.path) {
                                                            return (
                                                                <PreviewContainer key={index}>
                                                                    <ImagePreview
                                                                        src={file.path}
                                                                        alt={`file preview ${index}`}
                                                                    />
                                                                </PreviewContainer>
                                                            )
                                                        }
                                                    })}
                                                </Row>
                                            </Row>}
                                    </Row>
                                </Row>
                            </CardBody>
                        </Card>
                    </Row>}
                    <Row className="px-0 mx-2 ">
                        <Card className="mt-2 px-0  mr-2 ">
                            <CardBody className="pb-0">
                                <Row className="mb-4  mx-1">
                                    <Row className="mb-0 px-0">
                                        <p className="fw-bold font-size-16 mb-1">Deal Description</p>
                                        <p className="font-size-14 text-muted mb-0">All the informations related to the Deal</p>
                                    </Row>
                                    <hr className="mt-1 mb-2" />
                                    <Row className="mb-0 fw-bold">
                                        {deal ?.description ?.split("\n").map((item) => {
                                            return (
                                                <>
                                                    {item}
                                                    <br />
                                                </>
                                            )
                                        })}
                                    </Row>
                                </Row>
                            </CardBody>
                        </Card>
                    </Row>

                    <Row className="px-0 mx-2 ">
                        <Card className="mt-2 px-0  mr-2 ">
                            <CardBody className="pb-0">
                                <Row className="mb-4  mx-1">
                                    <Row className="mb-0 px-0">
                                        <p className="fw-bold font-size-16 mb-1">Feddback log</p>
                                        <p className="font-size-14 text-muted mb-0">Here all the information related to  feedbacks</p>
                                    </Row>
                                    <hr className="mt-1 mb-2" />
                                    <Row className="mb-0 fw-bold">
                                        <div className="table-view-deal">
                                            <Table>
                                                <thead>
                                                    <tr className="bgHeaderTable">
                                                        <th className="font-size-14 ">Title</th>
                                                        <th className="font-size-14 ">Feedback Creator</th>
                                                        <th className="font-size-14 ">Activity Type</th>
                                                        <th className="font-size-14 ">Description</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {feedback ?.map((item, index) => {
                                                        return (
                                                            <tr key={index} >
                                                                <th className="font-size-14 ">{item?.title}</th>
                                                                <th className="font-size-14 ">{item?.admin}</th>
                                                                <th className="font-size-14 ">{item?.activity}</th>
                                                                <th className="font-size-14 ">
                                                                    {item ?.description ?.split("\n").map((item) => {
                                                                        return (
                                                                            <>
                                                                                {item}
                                                                                <br />
                                                                            </>
                                                                        )
                                                                    })}
                                                                </th>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </Table>
                                            {deal ?.feedbacks ?.length ?
                                                <Row className="d-flex justify-content-end">
                                                    <Pagination items={deal ?.feedbacks} onChangePage={onChangeFeedback} />
                                                </Row> : null
                                            }
                                        </div>
                                    </Row>
                                </Row>
                            </CardBody>
                        </Card>
                    </Row>
                    <Row className="px-0 mx-2 ">
                        <Card className="mt-2 px-0  mr-2 ">
                            <CardBody className="pb-0">
                                <Row className="mb-4  mx-1">
                                    <Row className="mb-0 px-0">
                                        <h5 className="fw-bold">Activity Log</h5>
                                        <p className="font-size-14 text-muted mb-0">Here all the information related to  activities</p>
                                    </Row>
                                    <hr className="mt-1 mb-2" />
                                    <Row className="mb-0 fw-bold">
                                        <div className="table-view-deal">
                                            <Table>
                                                <thead>
                                                    <tr className="bgHeaderTable">
                                                        <th className="font-size-14 ">Date</th>
                                                        <th className="font-size-14 ">Sales Rep</th>
                                                        <th className="font-size-14 ">Activity Type</th>
                                                        <th className="font-size-14 ">Status</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {activities?.length !== 0 ? activities ?.map((item, index) => {
                                                        return (
                                                            <tr key={index} >
                                                                <th className="font-size-14 ">{item?.date}</th>
                                                                <th className="font-size-14 ">{item?.owner}</th>
                                                                <th className="font-size-14 ">{item?.activity_type}{item.activity_type === "Visit" ?
                                                                    <div>
                                                                        <br />Locaion : {item?.location}
                                                                    </div>
                                                                    : null}
                                                                </th>
                                                                <th className="font-size-14 ">{item?.status}</th>
                                                            </tr>
                                                        )
                                                    }) : null}
                                                </tbody>
                                            </Table>
                                            {deal ?.activities ?.length ?
                                                <Row className="d-flex justify-content-end">
                                                    <Pagination items={deal ?.activities} onChangePage={onChangeActivities} />
                                                </Row> : null
                                            }
                                        </div>
                                    </Row>
                                </Row>
                            </CardBody>
                        </Card>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

const getBackGround = (status) => {
    return status === "Contacted" ? "#db1fdb"
        : status === "Uncontacted" ? "#74788d"
            : status === "Lost" ? "#bf060b"
                : status === "Won" ? "#34e38f"
                    : status === "Open" ? "#50a5f1" :
                        status === "Unreachable" ? "#556ee6" : "#f1874c"

}
const toCurrency = (number) => {
    const numberInt = parseInt(number)
    const formatter = new Intl.NumberFormat("en-US");
    return formatter.format(numberInt);
}
export default ViewDealPage
